var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"am-app",attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"router","mode":"out-in"}},[_c('router-view'),_c('router-view',{key:_vm.$route.fullPath,attrs:{"name":"post"}})],1),_c('div',{staticClass:"whatsapp",on:{"click":function($event){return _vm.onClick('whatsapp')}}},[_c('div',{staticClass:"whatsapp--icon"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }